import { isAnyOf } from '@reduxjs/toolkit';

import { AppStartListening } from '../listenerMiddleware';
import { actions as userActions } from '../user/reducer';
import { getUserLocations } from '../user/thunks';
import { getMenus, getNutrition } from './thunks';

const addMenuListeners = (startListening: AppStartListening) => {
  startListening({
    matcher: isAnyOf(getUserLocations.fulfilled, userActions.updateUserLocation),
    effect: (_, listenerApi) => {
      const { dispatch } = listenerApi;
      dispatch(getMenus());
      dispatch(getNutrition());
    },
  });
};

export default addMenuListeners;
